import React from 'react';
import { NavLink } from 'react-router-dom';
import { TweenMax } from 'gsap';

export class Nav extends React.Component {
	render() {
        return (
		  	<div id="nav">
		    	<NavLink to="/before" activeClassName="is-active" exact={true}><div id="before-btn" className="nav-btn"></div></NavLink>
		    	<NavLink to="/lowercase" activeClassName="is-active" exact={true}><div id="lc-btn" className="nav-btn"></div></NavLink>
		    	<NavLink to="/uppercase" activeClassName="is-active" exact={true}><div id="uc-btn" className="nav-btn"></div></NavLink>
		    	<NavLink to="/num" activeClassName="is-active" exact={true}><div id="num-btn" className="nav-btn"></div></NavLink>
		    	<NavLink to="/words" activeClassName="is-active" exact={true}><div id="wordlist-btn" className="nav-btn"></div></NavLink>
		    	<NavLink to="/own" activeClassName="is-active" exact={true}><div id="own-btn" className="nav-btn"></div></NavLink>
			</div>
		);
    }
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/global/Nav.js